import { useParams } from "react-router-dom";
import ClientLayout from "../../components/Layout/ClientLayout";
import NoImage from "../../assets/images/No_Image_Available.jpg";
import Kinangop2 from "../../assets/images/kinangop1.jpg";
import Kinangop3 from "../../assets/images/ololokwe.jpg";
import Kinangop4 from "../../assets/images/table_mountain.jpg";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import {
  useGetAdventuresDetailQuery,
  useGetAdventuresQuery,
  useGetDestinationsDetailQuery,
  useGetDestinationsImagesQuery,
} from "../../apiCaller/apis/getApi";
import HtmlContent from "../../utils/DisplayHTML";
import EventComponent from "../../components/eventCard/EventComponent";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { PiMountainsFill, PiPathBold } from "react-icons/pi";
import { FaSortAmountUpAlt, FaWalking } from "react-icons/fa";
import { FaChildren } from "react-icons/fa6";
import { MdAccessTimeFilled, MdLocationPin } from "react-icons/md";
import { GrMapLocation } from "react-icons/gr";
import { GiStrong } from "react-icons/gi";
import { SlCalender } from "react-icons/sl";

import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
  InfoWindow,
} from "@vis.gl/react-google-maps";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Navigation, EffectCoverflow } from "swiper/modules";
import ButtonComponent from "../../components/button/Button";
import PriceTable from "./priceTable";
import SpinningLoader from "../../components/SpinningLoader/SpinningLoader";

const EventDetail = () => {
  const [events, setEvents] = useState([]);
  const [coverImage, setCoverImage] = useState();
  const [priceData, setPriceData] = useState([]);
  const [location, setLocation] = useState({
    lat: -0.9187714,
    lng: 36.4480015,
  });
  const { eventId } = useParams();
  const {
    data: destination,
    error: destinationError,
    isLoading: destinationIsLoading,
    isFetching: destinationIsFetching,
  } = GetTableListAPI({ adventureId: eventId }, useGetAdventuresDetailQuery);

  const {
    data: destinationImages,
    error: destinationImagesError,
    isLoading: destinationImagesIsLoading,
    isFetching: destinationImagesIsFetching,
  } = GetTableListAPI(
    { destinationId: destination?.destinationId },
    useGetDestinationsImagesQuery
  );

  const {
    data: adventures,
    error: adventuresError,
    isLoading: adventuresIsLoading,
    isFetching: adventuresIsFetching,
  } = GetTableListAPI({}, useGetAdventuresQuery);

  useEffect(() => {
    if (adventures !== undefined && adventures?.results !== undefined) {
      setEvents(adventures?.results);
    }
  }, [adventures]);

  useEffect(() => {
    if (destination !== undefined && destination?.priceGroups?.length > 0) {
      let prices = [];
      destination?.priceGroups.forEach((element) => {
        prices.push({
          name: element.group,
          amount: element.amount,
          currency: element.currency,
        });
      });
      setPriceData(prices);
    }
  }, [destination]);

  useEffect(() => {
    if (destinationImages !== undefined && destinationImages.length > 0) {
      setCoverImage(destinationImages.find((x) => x.isDisplayImage === true));
    }
  }, [destinationImages]);

  const handleClick = (image) => {
    console.log(image);
    setCoverImage(image);
  };

  console.log(priceData);
  return (
    <ClientLayout>
      <div className="px-10 md:px-16 lg:px-24">
        {/* <h1 className="text-2xl font-semibold">
          Reijnders Musy Super Green Field
        </h1>

        <div className="flex items-center text-sm text-gray-500 mt-1 space-x-2">
          <span className="text-yellow-500">★ 4.7</span>
          <span>(253 reviews)</span>
          <span>·</span>
          <span>Jl. Impesak Cicurian, Cicuruy, Bandung, Cicuruy, Bandung</span>
        </div> */}

        <div className=" mt-4">
          {/* Main large image */}
          <div className="relative w-full h-[300px] lg:h-[500px]">
            {/* Overlay */}
            <div className="absolute inset-0 bg-color-primary-dark2 opacity-30 z-10"></div>

            {/* Background Image */}
            {destinationImagesIsFetching || destinationImagesIsLoading ? (
              <div className="h-full flex items-center justify-center">
                {" "}
                <SpinningLoader isLoading={true} hasData={false} />{" "}
              </div>
            ) : (
              <img
                src={coverImage?.image ? coverImage?.image : NoImage}
                alt="Main View"
                className="w-full h-full object-cover rounded-lg z-0"
              />
            )}

            {/* Title */}
            <div className="absolute left-1/2 top-[40%] transform -translate-x-1/2 -translate-y-1/2 z-20 text-center">
              <div className="text-5xl md:text-7xl text-white font-bold">
                {destination?.Value?.name}
              </div>
            </div>

            {/* Swiper Carousel */}
            <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[70%] lg:w-[50%] flex justify-center z-30">
              <div className="w-full">
                <Swiper
                  effect="coverflow"
                  slidesPerView={1}
                  breakpoints={{
                    300: { slidesPerView: 2 },
                    640: { slidesPerView: 2 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}
                  spaceBetween={20}
                  coverflowEffect={{
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                  }}
                  loop={true}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: true,
                  }}
                  navigation={true}
                  modules={[EffectCoverflow, Autoplay, Navigation]}
                >
                  {destinationImages?.length > 0 ? (
                    destinationImages.map((destinationImage, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className="cursor-pointer h-44 lg:h-64 w-60 lg:w-80"
                          onClick={() => handleClick(destinationImage)}
                        >
                          <img
                            src={destinationImage.image || NoImage}
                            alt="destination"
                            className="h-full w-full bg-cover rounded-lg shadow-md"
                          />
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <div className="text-white text-center">
                        No images available
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
            </div>
          </div>

          {/* ))} */}

          {/* Overlay +12 */}
          {/* <div className="relative">
            <img
              src={Kinangop}
              alt="More images"
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
              <span className="text-white text-xl font-semibold">+12</span>
            </div>
          </div> */}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4  gap-0 lg:gap-32 my-32 ">
          <div className="col-span-3">
            <div className="text-5xl text-color-primary-dark1">
              Explore {destination?.name}
            </div>
            {destinationIsLoading || destinationIsFetching ? (
              <div className="">
                <SpinningLoader isLoading={true} hasData={false} />
              </div>
            ) : (
              <div>
                <div className="my-8">
                  <HtmlContent
                    htmlData={
                      // "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio. Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio."
                      destination?.description
                    }
                  />
                </div>

                <div>
                  <div className="text-4xl text-color-primary-dark1">
                    Distance And Stats
                  </div>

                  <div>
                    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:space-x-0 lg:space-x-5 gap-5 my-6 lg:my-10">
                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <PiMountainsFill size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Max Elevation
                            </div>
                            <div className="text-2xl font-bold">
                              {destination?.maxElevation}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <FaSortAmountUpAlt size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Elevation Gain
                            </div>
                            <div className="text-2xl font-bold">
                              {destination?.elevationGain}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <FaWalking size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Distance (KM)
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.distanceInKm}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:space-x-0 lg:space-x-5 gap-5 my-6 lg:my-10">
                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <MdAccessTimeFilled size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Duration
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.duration}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <GrMapLocation size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Country
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.country}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <MdLocationPin size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Location
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.location}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:space-x-0 lg:space-x-5 gap-5 my-6 lg:my-10">
                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <GiStrong size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Difficulty
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.difficulty}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <FaChildren size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Is Child Friendly
                            </div>
                            <div className="text-2xl font-bold">
                              {" "}
                              {destination?.isChildFriendly ? "True" : "False"}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className=" flex-1 border-[1px] rounded-lg border-color-gray-dark">
                        <div className="flex space-x-3">
                          <div className="border-r-[1px] border-color-primary-dark1 px-5 py-3">
                            <PiPathBold size={30} color="#040624" />
                          </div>

                          <div className="py-2">
                            <div className="text-color-primary-dark1 font-semibold">
                              Is Traverse
                            </div>
                            <div className="text-2xl font-bold">
                              {destination?.isTraverse
                                ? "Traverse"
                                : "Not Traverse"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* MAP */}
                  {/* <div className="my-10">
              
              <APIProvider apiKey="AIzaSyCkgjqMfIJDoofa7s7hYF2JdgSTo-kCZ9A">
                <div className="h-[400px]">
                  
                  <Map
                    zoom={10}
                    center={location}
                    mapId={"eedf04e74950ca44"}
                  >
                    <AdvancedMarker
                      position={location}
                    >
                      
                    </AdvancedMarker>
                  </Map>
                </div>
              </APIProvider>
            </div> */}
                </div>

                <div className="my-16">
                  <div className="text-4xl text-color-primary-dark1">
                    {destination?.name} Itinerary
                  </div>
                  <div>
                    <HtmlContent
                      htmlData={
                        // "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio. Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio."
                        destination?.itinerary
                      }
                    />
                  </div>
                </div>

                <div>
                  <div className="text-4xl text-color-primary-dark1 my-5">
                    Charges
                  </div>
                  <PriceTable data={priceData} />
                </div>

                <div className="flex flex-col lg:flex-row items-center space-x-0 lg:space-x-10 space-y-5 lg:space-y-0 my-10">
                  <div className="flex-1 w-full">
                    <div className="text-4xl text-color-primary-dark1">
                      What to wear
                    </div>
                    <div>
                      {" "}
                      <HtmlContent
                        htmlData={
                          // "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio. Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio."
                          destination?.whatToWear
                        }
                      />
                    </div>
                  </div>
                  <div className="flex-1 w-full">
                    <div className="text-4xl text-color-primary-dark1">
                      What to Carry
                    </div>
                    <div>
                      {" "}
                      <HtmlContent
                        htmlData={
                          // "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio. Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic maxime nam et assumenda magni amet delectus consectetur quisquam iste optio."
                          destination?.whatToCarry
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-span-1">
            <div className="text-5xl text-color-primary-dark1">Timelines</div>

            {destinationIsLoading || destinationIsFetching ? (
              <div className="">
                <SpinningLoader isLoading={true} hasData={false} />
              </div>
            ) : (
              <div className="my-6">
                <div className="my-5">
                  <div className="flex items-center space-x-5">
                    <div>
                      <SlCalender color="grey" />
                    </div>
                    <div className="font-bold">Date and Time</div>
                  </div>
                  <div>
                    <>
                      {new Date(destination?.startDate).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        }
                      )}{" "}
                      -{" "}
                      {new Date(destination?.endDate).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        }
                      )}
                    </>
                  </div>
                </div>

                <div className="my-5">
                  <div className="flex items-center space-x-5">
                    <div>
                      <MdLocationPin color="grey" />
                    </div>
                    <div className="font-bold">Location</div>
                  </div>
                  <div>{destination?.location}</div>
                </div>

                <div className="my-10">
                  <a target="_blank" href={destination?.bookingLink}>
                    <ButtonComponent
                      name={"Book Now"}
                      type="book"
                      className={"!py-5"}
                    />
                  </a>
                </div>
              </div>
            )}

            <div className="text-5xl text-color-primary-dark1 mt-10 lg:mt-16 ">
              Other Events
            </div>
            {adventuresIsLoading || adventuresIsFetching ? (
              <div className="">
                <SpinningLoader isLoading={true} hasData={false} />
              </div>
            ) : (
              <div>
                {events.slice(0, 3).map((event, index) => (
                  <div className="my-5 pb-5 border-b-2 mr-0 lg:mr-28">
                    <EventComponent adventure={event} imageHeigth={true} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default EventDetail;
